import React from "react";
import { Badge } from "antd";
import { BellFilled } from "@ant-design/icons";

const NotificationBell = ({ unreadCount = 0, onClick }) => {
  const hasUnread = unreadCount > 0;

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <Badge
      dot={hasUnread}
      dotColor="#ff4d4f"
      size="small"
      offset={[-2, 2]}
    >
      <BellFilled
        onClick={handleClick}
        style={{
          fontSize: 18,
          color: "#ffffff",
          cursor: "pointer",
          fontWeight: hasUnread ? "bold" : "normal",
        }}
        aria-label="Notifications"
      />
    </Badge>
  );
};

export default NotificationBell;